export const WEEK_DAYS: number[] = [2, 3, 4, 5, 6, 7, 1]; // 2-пн, 3-вт, 4-ср, 5-чт, 6-пт, 7-сб, 1-вс (from java)
